import { createReducer, on, Action } from '@ngrx/store';
import { IFile, IFileDetail } from '../../../models/file';
import * as FileActions from '../actions/index';

const initialState: FileState = {
  draftFiles: [],
  selectedFileDetail: null,
  fileDetailLoading: false,
  fileDetailError: null,
  deleteLoading: false,
  deleteError: null,
};

export interface FileState {
  draftFiles: IFile[];
  selectedFileDetail: IFileDetail | null;
  fileDetailLoading: boolean;
  fileDetailError: unknown;
  deleteLoading: boolean;
  deleteError: unknown;
}

const fileReducer = createReducer(
  initialState,
  on(FileActions.FileUiActions.GetDraftFiles, (state) => {
    return {
      ...state,
    };
  }),

  on(FileActions.FileApiActions.GetDraftFilesSuccess, (state, { payload }) => {
    return {
      ...state,
      draftFiles: payload,
    };
  }),

  on(FileActions.FileApiActions.GetDraftFilesFailure, (state) => {
    return {
      ...state,
    };
  }),

  on(FileActions.FileUiActions.GetFileDetail, (state) => {
    return {
      ...state,
      fileDetailLoading: true,
      fileDetailError: null,
    };
  }),

  on(FileActions.FileApiActions.GetFileDetailSuccess, (state, { fileDetail }) => {
    return {
      ...state,
      selectedFileDetail: fileDetail,
      fileDetailLoading: false,
    };
  }),

  on(FileActions.FileApiActions.GetFileDetailFailure, (state, { errors }) => {
    return {
      ...state,
      fileDetailLoading: false,
      fileDetailError: errors,
    };
  }),

  on(FileActions.FileUiActions.DeleteFile, (state) => {
    return {
      ...state,
      deleteLoading: true,
      deleteError: null,
    };
  }),

  on(FileActions.FileApiActions.DeleteFileSuccess, (state, { fileId }) => {
    return {
      ...state,
      deleteLoading: false,
      draftFiles: state.draftFiles.filter((file) => file.id !== fileId),
    };
  }),

  on(FileActions.FileApiActions.DeleteFileFailure, (state, { errors }) => {
    return {
      ...state,
      deleteLoading: false,
      deleteError: errors,
    };
  })
);

export function FileReducer(state: FileState = initialState, action: Action): FileState {
  return fileReducer(state, action);
}

